// Copied from backend genericExport.dto.ts to ensure exact structure match
export interface InventoryData {
    generalData: {
        companyName: string;
        companyAdress: string;
        companyZIP: string;
        companyCity: string;
    };
    hasCP: boolean;
    hasMM: boolean;
    MMdata: MMData | null;
    CPData: CPData | null;
}

export interface MMData {
    tableHeaders: {
        section: string;
        descriptionTitle: string;
        documentTitle: string;
        assigneeTitle: string;
    };
    tasks: MMTask[];
}

export interface MMTask {
    taskSection: string;
    taskDescription: string;
    document: string;
    assignee: string;
}

export interface CPData {
    tableHeaders: {
        section: string;
        descriptionTitle: string;
        documentTitle: string;
        bsTitle: string;
        isTitle: string;
        generalTitle: string;
    };
    generalTasks: CPTask[];
    BalanceSheetTasks: CPTask[];
    IncomeStatementTasks: CPTask[];
}

export interface CPTask {
    taskSection: string;
    taskDescription: string;
    document: string;
}
